export default {
  type: 'object',
  properties: {
    0: {
      type: 'object',
      properties: {
        assetPackageId: {
          type: 'string'
        },
        current_reward_day: {
          type: 'integer'
        },
        current_reward_day_index: {
          type: 'integer'
        },
        daily_bonus_currency: {
          type: 'string'
        },
        login_streak_bonus: {
          type: 'integer'
        },
        login_streak_day: {
          type: 'integer'
        },
        player_tier: {
          type: 'string'
        },
        prize_index: {
          type: 'integer'
        },
        wheel_hero: {
          type: 'boolean'
        },
        login_streak_coins_list: {
          type: 'object',
          patternProperties: {
            '[0-1000]+': {
              type: 'object',
              properties: {
                amount: {
                  type: 'integer'
                }
              },
              required: ['amount']
            }
          },
          minProperties: 10,
          maxProperties: 10
        },
        login_streak_loyalty_list: {
          type: 'object',
          patternProperties: {
            '[0-1000]+': {
              type: 'object',
              properties: {
                amount: {
                  type: 'string'
                }
              },
              required: ['amount']
            }
          },
          minProperties: 10,
          maxProperties: 10
        },
        member_tiers: {
          type: 'object',
          patternProperties: {
            '[0-1000]+': {
              type: 'object',
              properties: {
                daily_bonus_boost_percentage: {
                  type: 'integer'
                },
                points_required: {
                  type: 'integer'
                },
                tier_name: {
                  type: 'string'
                }
              },
              required: ['daily_bonus_boost_percentage', 'points_required', 'tier_name']
            }
          },
          minProperties: 1
        },
        spinner_items: {
          type: 'object',
          patternProperties: {
            '[0-1000]+': {
              type: 'object',
              properties: {
                0: {
                  type: 'string'
                },
                1: {
                  type: 'integer'
                },
                2: {
                  type: 'integer'
                },
                3: {
                  type: 'string'
                }
              },
              required: ['0', '1', '2', '3']
            }
          },
          minProperties: 16,
          maxProperties: 16
        }
      },
      required: ['assetPackageId', 'current_reward_day', 'current_reward_day_index', 'daily_bonus_currency', 'login_streak_bonus', 'login_streak_day', 'player_tier', 'prize_index', 'wheel_hero', 'login_streak_coins_list', 'login_streak_loyalty_list', 'member_tiers', 'spinner_items']
    }
  }
};